module.exports = __webpack_public_path__ + "img/gesture_yeah.45c37991.png";